import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { FormattedMessage } from 'react-intl';
import DeleteIcon from '@material-ui/icons/Delete';

import { load, updateFilter, loadAutocomplete, destroy } from 'Actions/interest';
import DataTable from 'Components/DataTable';
import Header from 'Components/Header';
import Button from 'Common/CustomButtons/Button';
import { lightboxDecorator, pageTitleDecorator } from 'Decorators';
import { QueryFilterType, InterestType, DataTableMetadataType } from 'Types';
import {
    DATA_TABLE_COLUMN_TYPE_ACTIONS,
    DATA_TABLE_COLUMN_TYPE_LINK,
    DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_SINGLE,
} from 'Constants';

@pageTitleDecorator('interests')
@lightboxDecorator({
    title: 'title.warning',
    text: 'confirm.delete',
})
@connect(
    store => ({
        data: store.interestsList.data,
        filter: store.interestsList.filter,
        metadata: store.interestsList.metadata,
        dataAutocomplete: store.interestsAutocomplete.data,
        filterAutocomplete: store.interestsAutocomplete.filter,
    }),
    dispatch => ({
        load: filter => dispatch(load(filter)),
        updateFilter: filter => dispatch(updateFilter(filter)),
        loadAutocomplete: filter => dispatch(loadAutocomplete(filter)),
        redirectToCreate: () => dispatch(push('/settings/interests/create')),
        handleDeleteInterest: (id, filter) => dispatch(destroy(id)).then(() => dispatch(load(filter))),
    })
)
export default class InterestsList extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        data: PropTypes.arrayOf(InterestType).isRequired,
        filter: QueryFilterType.isRequired,
        metadata: DataTableMetadataType,
        load: PropTypes.func.isRequired,
        updateFilter: PropTypes.func.isRequired,
        dataAutocomplete: PropTypes.arrayOf(InterestType),
        filterAutocomplete: QueryFilterType,
        loadAutocomplete: PropTypes.func,
        redirectToCreate: PropTypes.func.isRequired,
        handleDeleteInterest: PropTypes.func.isRequired,
        openLightbox: PropTypes.func.isRequired,
    };

    state = {
        key: Math.random()
    };

    loadOptions = input => {
        const { filterAutocomplete } = this.props;
        this.props.loadAutocomplete(filterAutocomplete.merge({
            where: {title: { like: `%${input}%` }}
        }));
    };

    onDeleteInterest = (id) => {
        const { openLightbox, handleDeleteInterest, filter } = this.props;
        openLightbox(() => handleDeleteInterest(id, filter));
    };

    getColumns = () => {
        const { dataAutocomplete } = this.props;

        return [
            {
                key: 'id',
                col: { width: '5%' },
                title: 'data_table.id',
                sortable: true,
            },
            {
                key: 'title',
                col: { width: '50%' },
                title: 'data_table.title',
                type: DATA_TABLE_COLUMN_TYPE_LINK,
                filterType: DATA_TABLE_FILTER_TYPE_AUTOCOMPLETE_SINGLE,
                loadOptions: this.loadOptions,
                options: dataAutocomplete.map(item => ({
                    value: item.title,
                    label: item.title,
                })),
                sortable: true,
                filterable: true,
                filterPlaceholder: 'data_table.filter.interest_title',
                link: {
                    to: '/settings/interests/:id',
                    placeholders: {
                        id: item => item.id,
                    },
                },
            },
            {
                key: 'users_count',
                col: { width: '45%' },
                title: 'data_table.users_count',
                sortable: true,
                relation: 'users',
                handler: item => {
                    return item.__meta__.users_count;
                },
            },
            {
                key: 'link',
                col: { width: '5%' },
                title: 'data_table.empty',
                type: DATA_TABLE_COLUMN_TYPE_ACTIONS,
                actions: [
                    {
                        name: 'Delete',
                        icon: <DeleteIcon />,
                        onClick: item => this.onDeleteInterest(item.id)
                    },
                ],
            },
        ];
    };

    render() {
        const { data, filter, load, metadata, updateFilter } = this.props;
        const { key } = this.state;

        return (
            <div className="wrapJournalList">
                <Header title="title.interests">
                    <Button  color="primary" onClick={this.props.redirectToCreate}>
                        <FormattedMessage id="button.interest.create.link" />
                    </Button>
                </Header>

                <DataTable
                    columns={this.getColumns()}
                    metadata={metadata}
                    data={data}
                    filter={filter}
                    load={load}
                    updateFilter={updateFilter}
                    icon={false}
                    key={key}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Settings/containers/InterestsList.jsx